module.exports = __webpack_public_path__ + "static/media/attachment-icon.b54eee9c.svg";